/* eslint-disable react-hooks/rules-of-hooks */
import { useCookies } from 'react-cookie'
import { useParams } from 'react-router-dom'

export const getRequestHeaders = () => {
    const params = useParams()
    const [cookies] = useCookies([''])
    // @ts-expect-error TODO: fix cookie types
    const { authorization, account_id } = cookies

    return {
        accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authorization}`,
        Accountid: account_id,
        Subnetid: params.id,
    }
}
